import { render, staticRenderFns } from "./AlertUsersTableGBS.vue?vue&type=template&id=acfb82f4&scoped=true&"
import script from "./AlertUsersTableGBS.vue?vue&type=script&lang=js&"
export * from "./AlertUsersTableGBS.vue?vue&type=script&lang=js&"
import style0 from "./AlertUsersTableGBS.vue?vue&type=style&index=0&id=acfb82f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfb82f4",
  null
  
)

export default component.exports